export default class Constants {
  public static Pages = class {
    static home = '/';
    static changePassword = '/change-password';
    static changePasswordConfirm = '/change-password-confirm';
    static logOff = '/log-off';
    static loggingTest = '/logging-test';
    static accessError = '/access-error';
    static redirectLogin = '/redirect-login';
    static technicalError = '/technical-error';
    static mobileTimeoutError = '/mobile/timeout-error';
    static afterCentralization = '/aftercentralization';
    static catchAll = '*';
    static mobile = '/mobile';
    static mobileChangePassword = '/mobile/change-password';
    static mobileChangePasswordConfirm = '/mobile/change-password-confirm';
    static authorize = '/authorize';
    static readonly authorizeCallback = '/authorize/callback';
  };
  public static LocalStorageKeys = class {
    static authorizeParams = 'aw-auth-ia-client-authorize-params';
  };
}
